import styled from "@emotion/styled";
import PropTypes from "prop-types";

import { withErrorBoundary } from "../../../ErrorBoundary";
import { CheckMarkIcon, Icon } from "../../../Icon";
import { Image, imageRoundedVariants } from "../../../Image";
import styles from "./GalleryImage.style";

const UploaderGalleryImageStyled = styled.div((props) => ({ ...styles(props) }));

const UploaderGalleryImage = ({
    image,
    name,
    id,
    value,
    onChange,
    onClick,
    checked,
    className,
    ...rest
}) => {
    // onChange
    const handleChange = (event, ...args) => {
        if (onChange) {
            onChange(event, ...args);
        }
    };

    if (!image) {
        return null;
    }

    const { id: imageId, name: imageName } = image;

    return (
        <UploaderGalleryImageStyled
            onClick={onClick}
            checked={checked}
            className={className}
            {...rest}
        >
            <input
                type="checkbox"
                name={name}
                id={id || imageId}
                value={value}
                checked={checked}
                onChange={handleChange}
            />
            <Image
                title={imageName}
                alt={imageName}
                image={image}
                ratio={1}
                width={360}
                height={360}
                rounded={imageRoundedVariants.SMALL}
            />
            <span className="uploaderGalleryImage_icon">
                <Icon icon={CheckMarkIcon} />
            </span>
        </UploaderGalleryImageStyled>
    );
};

UploaderGalleryImage.propTypes = {
    image: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
    name: PropTypes.string,
    id: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    className: PropTypes.string,
};

UploaderGalleryImage.defaultProps = {
    image: undefined,
    name: undefined,
    id: undefined,
    value: undefined,
    checked: false,
    onChange: () => {},
    onClick: () => {},
    className: undefined,
};

export default withErrorBoundary(UploaderGalleryImage);
